var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_16",
    "data-name": "Gruppe 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.034,
    height: 73.034,
    viewBox: "0 0 73.034 73.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M0,0H73.034V73.034H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M53.733,18.216h-42.6A9.117,9.117,0,0,0,2,27.345V45.6H14.172V57.776H50.69V45.6H62.862V27.345A9.117,9.117,0,0,0,53.733,18.216ZM44.6,51.69H20.259V36.474H44.6Zm9.129-21.3a3.043,3.043,0,1,1,3.043-3.043A3.052,3.052,0,0,1,53.733,30.388ZM50.69,3H14.172V15.172H50.69Z",
    transform: "translate(4.086 6.129)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter);
export default __webpack_public_path__ + "static/media/icon-printer.b3f863415418dc904249393a00989f97.svg";
export { ForwardRef as ReactComponent };